import React from "react";
import classNames from "classnames";
export const Item = ({ title, content }) => {
    return (React.createElement("li", { className: classNames("iztro-palace-center-item") },
        React.createElement("label", null, title),
        React.createElement("span", null, content)));
};
